import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { EUserType } from 'src/app/micro-services/user/enum/e-user-type';
import { UserCoach } from 'src/app/micro-services/user/models/user-coach';
import { ApiProviderService } from 'src/app/services/api-provider.service';

@Component({
  selector: 'app-form-coach',
  templateUrl: './form-coach.component.html',
  styleUrls: ['./form-coach.component.scss'],
})
export class FormCoachComponent implements OnInit {

  coachForm : FormGroup;
  @Input() coach: UserCoach;
  @Output() coachEvent = new EventEmitter<UserCoach>();

  constructor(
    private modalCtrl : ModalController,
    private apiProvider : ApiProviderService,
    private toastController : ToastController
  ) { }

  ngOnInit() {

    if(this.coach){
      this.coachForm = new FormGroup(
        {
          Name : new FormControl(this.coach.name, Validators.required),
          Firstname : new FormControl(this.coach.firstName, Validators.required),
          CompagnyNumber : new FormControl(this.coach.compagnyNumber, Validators.required),
          Email : new FormControl(this.coach.email, Validators.required),
          PhoneNumber : new FormControl(this.coach.phoneNumber, Validators.required),
          IsActive : new FormControl(this.coach.isActive),
        }
      );
    }else{
      this.coachForm = new FormGroup(
        {
          Name : new FormControl('', Validators.required),
          Firstname : new FormControl('', Validators.required),
          CompagnyNumber : new FormControl('', Validators.required),
          Email : new FormControl('', Validators.required),
          PhoneNumber : new FormControl('', Validators.required),
          IsActive : new FormControl(true),
        }
      );
    }

  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  validate(){
    if(this.coachForm.invalid)
    {
      this.coachForm.markAllAsTouched();
      return
    }

     // MODIFICATION 
    if(this.coach?.id)
    {
       this.apiProvider.editCoach({... this.coachForm.value, discriminator: EUserType.Coach, id : this.coach.id }).subscribe(
         (data) => {
           this.coachEvent.emit(data);
           return this.modalCtrl.dismiss(data, 'edit');
         },
         async (err) => {
           const toast = await this.toastController.create({
             message: "Erreur lors de l'edition",
             duration: 5000,
             buttons: [
               {
                 text: 'Compris',
                 role: 'cancel'
               }
             ]
           });
           await toast.present();
         }
       );
 
    }else{
       // CREATION 
      this.apiProvider.createCoach({... this.coachForm.value }).subscribe(
        (data) => {
          this.coachEvent.emit(data);
          return this.modalCtrl.dismiss(data, 'create');
        },
        async (err) => {
          const toast = await this.toastController.create({
            message: 'Erreur lors de la creation',
            duration: 5000,
            buttons: [
              {
                text: 'Compris',
                role: 'cancel'
              }
            ]
          });
          await toast.present();
        }
      );
    }
  }

}
